import { ElectronApi } from '@gem/call/Removable/packages/electron/ElectronApi';
import { SelectDesktopSharingScreenPopup } from '@gem/call/popups/SelectDesktopSharingScreenPopup/SelectDesktopSharingScreenPopup';
import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

export async function getDesktopScreenForSharing(): Promise<string | null> {
  if (ElectronApi.isMac) {
    const hasPermission = await ElectronApi.getScreenRecordingPermission();

    if (!hasPermission) {
      popupsTasks.showAlert({
        html: t('system_preferences_screen_sharing').replace(
          '{0}',
          `<a href="x-apple.systempreferences:com.apple.preference.security?Privacy_ScreenCapture">${t(
            'system_preferences_common'
          )}</a>`
        ),
      });

      return null;
    }
  }

  return new Promise((resolve) => {
    popupsTasks.openPopup(SelectDesktopSharingScreenPopup, {
      async onClose(electronSourceId?: string): Promise<void> {
        resolve(electronSourceId || null);
      },
    });
  });
}
